import type { LocationQuery } from 'vue-router'

/**
 * `/search` used `?searchquery=` until KFT-4023 renamed it to `?query=`.
 * Returns the query with the legacy param renamed, or `null` when there is
 * nothing to rewrite. An explicit `query` wins over the legacy value.
 */
export const renameLegacySearchQueryParam = (
  query: LocationQuery
): LocationQuery | null => {
  if (!('searchquery' in query)) return null

  const { searchquery, ...rest } = query
  return { ...rest, query: rest.query ?? searchquery }
}
